"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/molecules/simple-grid-pattern.tsx
import { useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function SimpleGridPattern(props) {
  const patternId = useId();
  return /* @__PURE__ */ jsxs("svg", { "aria-hidden": "true", className: "absolu\
te inset-0 size-full", children: [
    /* @__PURE__ */ jsx("title", { children: "Grid Pattern" }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("pattern", { id: patternId,
    width: "128", height: "128", patternUnits: "userSpaceOnUse", ...props, children: /* @__PURE__ */ jsx(
    "path", { d: "M0 128V.5H128", fill: "none", stroke: "currentColor" }) }) }),
    /* @__PURE__ */ jsx("rect", { width: "100%", height: "100%", fill: `url(#${patternId}\
)` })
  ] });
}
__name(SimpleGridPattern, "SimpleGridPattern");
export {
  SimpleGridPattern
};
